export const normalizePhoneForUrl = (phone: string) => {
  return phone.replace(/[^\d+]/g, "");
};
